'use strict';

import angular from 'angular';
import { UtilService } from './util.service.js';
import * as FilterService from './filter.service.js';

export default angular.module('georgeApp.util', [])
  .factory('Util', UtilService)
  .filter('sumFinancial', FilterService.sumFinancial)
  .filter('abs', FilterService.abs)
  .name;
